export default "__VITE_ASSET__HWVR9lYw__"